export const CONNECTIVITY_AUTO_PUSH_KEY = 'esan:connectivity-auto-push' as const;

export function isConnectivityAutoPushEnabled(): boolean {
  try {
    return globalThis.localStorage?.getItem(CONNECTIVITY_AUTO_PUSH_KEY) === '1';
  } catch {
    return false;
  }
}

export function setConnectivityAutoPushEnabled(enabled: boolean): void {
  try {
    if (enabled) globalThis.localStorage?.setItem(CONNECTIVITY_AUTO_PUSH_KEY, '1');
    else globalThis.localStorage?.removeItem(CONNECTIVITY_AUTO_PUSH_KEY);
  } catch {
    /* ignore */
  }
}
